import { WSBreadcrumbsItem } from "@wingspanhq/fe-component-library";
import { IPayerTaxFormResponse } from "@wingspanhq/payments/dist/interfaces";
import { useMemo } from "react";
import { useXWingspanExpansion } from "../../../../shared/hooks/useXWingspanExpansion";
import { useGoToTaxFilingDashboard } from "../../paths";
import { selectorTaxFormRecipientName } from "../../selectors/selectorTaxFormRecipientName";
import { getTaxFormOrganizationName } from "./RouteTaxFormDetails/getTaxFormOrganizationName";
import { useCurrentTaxFilingYear } from "../../utils/useCurrentTaxFilingYear";
import { useUserId } from "../../../../query/hooks/helpers";

export const useBreadcrumbs = (taxForm?: IPayerTaxFormResponse) => {
  const isOrganizationExist = useXWingspanExpansion();
  const currentYear = useCurrentTaxFilingYear();
  const userId = useUserId();

  const goToDashboard = useGoToTaxFilingDashboard();

  return useMemo(() => {
    if (!taxForm) {
      return;
    }

    const breadcrumbs: WSBreadcrumbsItem[] = [
      {
        label: `1099-filing dashboard (${currentYear})`,
        onClick: () => {
          goToDashboard();
        }
      }
    ];

    const organizationName = getTaxFormOrganizationName(taxForm);
    if (
      isOrganizationExist &&
      organizationName &&
      taxForm.clientId !== userId
    ) {
      breadcrumbs.push({
        label: organizationName,
        onClick: () => {
          goToDashboard({
            clientId: taxForm.clientId
          });
        }
      });
    }

    const name = selectorTaxFormRecipientName(taxForm);
    breadcrumbs.push({
      label: name
    });

    return breadcrumbs;
  }, [goToDashboard, isOrganizationExist, taxForm, userId]);
};
